export default {
    password_recovery: _usernameOrEmail => {
        return {
            url: '/password/recovery',
            method: 'POST',
            post_params: {
                usernameOrEmail: _usernameOrEmail
            }
        };
    }
};



// WEBPACK FOOTER //
// ./data/user/api.js